<template>
	<div class="about-container">
		<img class="popularBgImg" src="../assets/Home/popularBgImg.png" />
		<div class="detailsBox">
			<div class="title">
				感谢您选择岱屿画境AI创作平台，让我们携手创作最好的作品吧！
			</div>
			<el-form ref="baseInfoForm" hide-required-asterisk class="register-form" :model="baseInfoForm"
				:rules="baseInfoRules" inline>
				<el-form-item label="昵称：" prop="user_nickname">
					<div class="form-group" style="width: 4.1rem;">
						<input type="text" v-model="baseInfoForm.user_nickname" placeholder="请输入您的创作者昵称"
							class="form-input" />
					</div>
				</el-form-item>
				<el-form-item label="姓名：" prop="hs_name">
					<div class="form-group" style="width: 4.1rem;">
						<input type="text" v-model="baseInfoForm.hs_name" placeholder="请输入您的真实姓名，用于平台实名核验"
							class="form-input" />
					</div>
				</el-form-item>
				<el-form-item label="身份证号：" prop="sfz">
					<div class="form-group" style="width: 4.1rem;">
						<input type="email" v-model="baseInfoForm.sfz" placeholder="请输入您的身份证号码，用于平台实名核验"
							class="form-input" />
					</div>
				</el-form-item>
				<el-form-item label="手机号：" prop="mobile">
					<div class="form-group" style="width: 4.1rem;">
						<div class="phone-input-container">
							<input type="tel" v-model="baseInfoForm.mobile" maxlength="11" placeholder="请输入手机号码"
								class="phone-input" />
							<button type="button" @click="getVerificationCode" :disabled="countdown > 0"
								class="get-code-btn">{{countdown > 0 ? countdown + 's后重新获取': '获取验证码'}}</button>
						</div>
					</div>
				</el-form-item>
				<el-form-item label="验证码：" prop="code">
					<div class="form-group" style="width: 4.1rem;">
						<div class="verification-container">
							<input type="text" v-model="baseInfoForm.code" placeholder="请输入您的验证码"
								class="verification-input" />
							<span v-if="showVerificationError" class="error-message">验证码错误</span>
						</div>
					</div>
				</el-form-item>
				<el-form-item label="邮箱：" prop="user_email">
					<div class="form-group" style="width: 4.1rem;">
						<input type="email" v-model="baseInfoForm.user_email" placeholder="请输入邮箱（选填）"
							class="form-input" />
					</div>
				</el-form-item>
				<el-form-item label="登录密码：" prop="pwd">
					<div class="form-group" style="width: 4.1rem;">
						<input :type="showOldPwd ? 'text' : 'password'" v-model="baseInfoForm.pwd"
							placeholder="请设置您的登录密码" class="form-input" />
						<img class="showPwd" src="../assets/Personal/iconP.png" @click="showOldPwd = !showOldPwd"
							v-if="!showOldPwd" />
						<img class="showPwd" src="../assets/Personal/iconO.png" @click="showOldPwd = !showOldPwd"
							v-else />
					</div>
				</el-form-item>
				<el-form-item label="简介：" prop="hs_content">
					<div class="form-group" style="width: 7.7rem;">
						<div class="contentBox">
							<textarea v-model="baseInfoForm.hs_content" placeholder="请输入您的创作简介"></textarea>
							<div class="textNum">
								{{baseInfoForm.hs_content.length}}/ <span>500</span>
							</div>
						</div>
					</div>
				</el-form-item>
				<el-form-item label="作品图上传：" prop="inviteCode">
					<div class="imgList">
						<div class="imgItem" v-for="(item,index) in imgList" :key="index">
							<img class="imgItemImg" :src="item" />
							<img class="delete" @click="imgList.splice(index, 1)" src="../assets/Feedback/delete.png" />
						</div>
						<div class="addImgBox" @click="$refs.upload.$el.querySelector('input').click()"
							v-if="imgList.length != 6">
							<img class="addImg" src="../assets/Feedback/addImg.png" />
							上传图片
						</div>
					</div>
				</el-form-item>
			</el-form>
			<form class="register-form" v-if="false">
				<!-- 昵称输入 -->
				<div class="form-group">
					<div class="form-title">昵称：</div>
					<input type="text" v-model="nickname" placeholder="请输入昵称" class="form-input" />
				</div>
				<!-- 姓名输入 -->
				<div class="form-group">
					<div class="form-title">姓名：</div>
					<input type="text" v-model="name" placeholder="请输入姓名" class="form-input" />
				</div>
				<!-- 身份证号输入 -->
				<div class="form-group">
					<div class="form-title">身份证号：</div>
					<input type="text" v-model="idCard" placeholder="请输入身份证号" class="form-input" />
				</div>
				<!-- 手机号输入 -->
				<div class="form-group">
					<div class="form-title">手机号：</div>
					<div class="phone-input-container">
						<input type="tel" maxlength="11" v-model="phone" placeholder="请输入手机号码" class="phone-input" />
						<button type="button" @click="getVerificationCode" class="get-code-btn">获取验证码</button>
					</div>
				</div>
				<!-- 验证码输入 -->
				<div class="form-group">
					<div class="form-title">验证码：</div>
					<div class="verification-container">
						<input type="text" v-model="verificationCode" placeholder="请输入验证码" class="verification-input" />
						<span v-if="showVerificationError" class="error-message">验证码错误</span>
					</div>
				</div>
				<!-- 邮箱输入 -->
				<div class="form-group">
					<div class="form-title">邮箱：</div>
					<input type="email" v-model="email" placeholder="请输入邮箱（选填）" class="form-input" />
				</div>
				<!-- 密码输入 -->
				<div class="form-group">
					<div class="form-title">登录密码：</div>
					<input type="password" v-model="password" placeholder="请输入登录密码" class="form-input" />
				</div>
				<!-- 简介输入 -->
				<div class="form-group" style="width: 100%;align-items: flex-start;">
					<div class="form-title" style="margin-top: .16rem;">简介：</div>
					<div class="contentBox">
						<textarea placeholder="请输入反馈内容"></textarea>
						<div class="textNum">
							0/ <span>500</span>
						</div>
					</div>
				</div>
				<div class="form-group" style="width: 100%;align-items: flex-start;">
					<div class="form-title" style="margin-top: .16rem;">作品图上传：</div>
					<div class="imgList">
						<div class="imgItem">
							<img class="imgItemImg" src="../assets/Home/placeholder.png" />
							<img class="delete" src="../assets/Feedback/delete.png" />
						</div>
						<div class="addImgBox">
							<img class="addImg" src="../assets/Feedback/addImg.png" />
							上传图片
						</div>
					</div>
				</div>
				<!-- 服务协议 -->
				<div class="agreement-container">
					<label class="agreement-label">
						<img class="agreement-checkbox" src="../assets/Register/checkSel.png" v-if="agreeTerms" />
						<img class="agreement-checkbox" src="../assets/Register/checkNor.png" v-else />
						<span class="agreement-text">我已阅读并同意</span>
						<div class="agreement-link" @click="userAgree = true">《岱屿画境AI创作平台创作者注册协议》</div>
					</label>
				</div>

				<!-- 注册按钮 -->
				<button type="button" @click="register" class="register-btn">注册</button>
			</form>
			<div class="agreement-container">
				<label class="agreement-label">
					<img class="agreement-checkbox" src="../assets/Register/checkSel.png" v-if="agreeTerms" />
					<img class="agreement-checkbox" src="../assets/Register/checkNor.png" v-else />
					<span class="agreement-text">我已阅读并同意</span>
					<div class="agreement-link" @click="userAgree = true">《岱屿画境AI创作平台创作者注册协议》</div>
				</label>
			</div>

			<!-- 注册按钮 -->
			<button type="button" @click="register('baseInfoForm')" class="register-btn">注册</button>

			<!-- 去登录 -->
			<div class="login-link-container">
				已有账号？
				<router-link to="/login?key=creator" class="login-link">马上登录</router-link>
			</div>
		</div>
		<PopToast :imgPtahUrl="require('@/assets/Register/exclaim.png')" :desc="'您好，当前手机号已注册，请'" :descTwo="'输入新的手机号'"
			@clickOk="abnormalPop = false" v-if="abnormalPop" />
		<UserCreatorAgreeDialog :show="userAgree" @close="userAgree = false" />
		<el-upload ref="upload" name="image" action="https://ht.daiyuart.com/api.php/set/Other/upload_img"
			:show-file-list="false" :limit="6" multiple :on-success="handlePhotoSuccess">
		</el-upload>
		<PopToast :imgPtahUrl="require('@/assets/Feedback/sucIcon.png')" :desc="'您的注册申请已成功提交，平台审核人员会尽快联系您，请保持电话畅通哦！'"
			@clickOk="sucPop = false;$router.replace('/')" v-if="sucPop" />
	</div>
</template>

<script>
	import PopToast from '../components/PopToast.vue'
	import UserCreatorAgreeDialog from '../components/UserCreatorAgreeDialog.vue'
	export default {
		name: 'CreatorCenter',
		components: {
			PopToast,
			UserCreatorAgreeDialog
		},
		data() {
			return {
				userAgree: false,
				baseInfoForm: {
					mobile: '',
					pwd: '',
					sfz: '',
					user_nickname: '',
					user_email: '',
					hs_name: '',
					hs_content: '',
					hs_img: '',
					code: '',
				},
				baseInfoRules: {
					user_nickname: [{
						required: true,
						message: '请输入昵称',
						trigger: 'blur'
					}],
					hs_name: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}],
					sfz: [{
						required: true,
						message: '请输入身份证',
						trigger: 'blur'
					}],
					mobile: [{
						required: true,
						message: '请输入手机号',
						trigger: 'blur'
					}],
					code: [{
						required: true,
						message: '请输入验证码',
						trigger: 'blur'
					}],
					pwd: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}],
				},
				nickname: '',
				name: '',
				idCard: '',
				password: '',
				email: '',
				phone: '',
				imgList: [],
				verificationCode: '',
				agreeTerms: true,
				showVerificationError: false,
				showOldPwd: false,
				countdown: 0,
				sucPop: false,
				tipPop: false,
				abnormalPop: false
			}
		},
		methods: {
			//上传图片成功
			handlePhotoSuccess(response) {
				this.imgList.push(response.data)
			},
			getVerificationCode() {
				this.$refs.baseInfoForm.validateField('mobile', (valid) => {
					if (!valid) {
						this.$api.post('/Other/phone_code', {
							phone: this.baseInfoForm.mobile,
						}).then(res => {
							if (res.code == 1) {
								this.countdown = 60;
								// 倒计时
								const timer = setInterval(() => {
									this.countdown--;
									if (this.countdown <= 0) {
										clearInterval(timer);
									}
								}, 1000);
							} else {
								console.log(res.msg)
							}
							console.log(res)
						}).catch(err => {
							console.log(err);
						})
					} else {
						return
					}
				});
			},
			register(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (!this.agreeTerms) return this.$message.warning('请阅读并同意用户协议')
						this.$api.post('/Basics/hs_register', {
							...this.baseInfoForm,
							hs_img: this.imgList.length ? this.imgList.join(',') : '',
						}).then(res => {
							if (res.code == 1) {
								this.sucPop = true
								this.abnormalPop = false
								this.showVerificationError = false
								// localStorage.setItem('token', res.data)
								// this.$api.post('/UserD/user_details', {}).then(result => {
								// 	if (result.code == 1) {
								// 		localStorage.setItem('userId', result.data.id)
								// 		this.$store.dispatch('updateShopStatus', result.data
								// 			.shop_status)
								// 		this.$router.replace('/data-board')
								// 		this.$message.success(res.msg)
								// 	} else {
								// 		console.log(result.msg)
								// 	}
								// }).catch(err => {
								// 	console.log(err);
								// })
							} else {
								if (res.msg == '手机号已存在') {
									this.abnormalPop = true
								} else if (res.msg == '请先获取验证码') {
									this.showVerificationError = true
								}
							}
						}).catch(err => {
							console.log(err);
						})
					} else {
						return false
					}
				})
			}
		},
		mounted() {
			console.log('关于我们页面已加载')
		}
	}
</script>

<style lang="scss" scoped>
	.about-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		background: #FDFDF4;
		min-height: 100vh;
		position: relative;

		.popularBgImg {
			position: absolute;
			width: 100%;
			bottom: 0;
			left: 0;
		}
	}

	.detailsBox {
		margin: .6rem auto .8rem;
		display: flex;
		flex-direction: column;
		width: 9.78rem;
		border-radius: .12rem;
		background: #FFFFFF;
		overflow: hidden;
		z-index: 1;

		.title {
			height: .9rem;
			display: flex;
			align-items: center;
			padding: 0 .6rem;
			font-weight: 500;
			font-size: .24rem;
			color: #4C4943;
			background: #CDBB98;
		}

		.register-form {
			width: 100%;
			display: flex;
			flex-direction: column;
			padding: .16rem .6rem 0 0;
			font-weight: 400;
			font-size: .16rem;
			color: #252525;
		}

		.form-group {
			display: flex;
			align-items: center;
			width: 5.48rem;
			position: relative;

			.showPwd {
				position: absolute;
				top: calc(50% - .12rem);
				right: .1rem;
				width: .24rem;
				height: .24rem;
				cursor: pointer;
			}

			// margin-top: .16rem;
		}

		.form-title {
			width: 1.38rem;
			font-weight: 400;
			font-size: .14rem;
			color: #252525;
			text-align: right;
		}

		.form-input {
			width: 4.1rem;
			height: 0.44rem;
			border: .01rem solid #EFD8B8;
			border-radius: 0.04rem;
			padding: 0 0.16rem;
			font-size: 0.14rem;
			color: #333333;
			outline: none;
			transition: border-color 0.3s ease;

			// &:focus {
			// 	border-color: #E29358;
			// }

			&::placeholder {
				color: #999999;
			}
		}

		// 手机号和验证码输入框样式
		.phone-input-container,
		.verification-container,
		.invite-container {
			width: 4.1rem;
			height: 0.44rem;
			border: .01rem solid #EFD8B8;
			border-radius: 0.04rem;
			padding: 0 0.16rem;
			font-size: 0.14rem;
			color: #333333;
			outline: none;
			display: flex;
			align-items: center;
			justify-content: space-between;
		}

		.phone-input,
		.verification-input,
		.invite-input {
			border: none;
			outline: none;
			padding: 0 0;

			font-size: 0.14rem;
			color: #333333;

			&::placeholder {
				color: #999999;
			}
		}

		.get-code-btn {
			padding: 0 0;
			color: #E29358;
			font-size: 0.14rem;
			cursor: pointer;

			&:disabled {
				background: #FFFFFF;
				color: #CCCCCC;
				border-color: #CCCCCC;
				cursor: not-allowed;
			}
		}

		// 错误提示样式
		.error-message {
			background: #F56C6C;
			padding: 0.04rem 0.09rem;
			border-radius: 0.02rem;
			font-weight: 400;
			font-size: 0.12rem;
			color: #FFFFFF;
			line-height: .22rem;
		}

		.contentBox {
			width: 100%;
			height: 3.2rem;
			background: #FFFFFF;
			border-radius: .04rem;
			border: .01rem solid #EFD8B8;
			padding: .12rem .12rem;
			position: relative;

			textarea {
				width: 100%;
				height: 100%;
				font-size: .14rem;
				padding: 0 0;
				border: none;
			}

			.textNum {
				position: absolute;
				right: .12rem;
				bottom: .12rem;
				display: flex;
				align-items: center;
				font-weight: 400;
				font-size: .14rem;
				color: #252525;

				span {
					color: #999999;
				}
			}
		}

		.imgList {
			display: flex;
			flex-wrap: wrap;

			.imgItem {
				margin-right: .16rem;
				display: flex;
				width: .86rem;
				height: .86rem;
				border-radius: .04rem;
				overflow: hidden;
				position: relative;

				.delete {
					position: absolute;
					top: .05rem;
					right: .05rem;
					width: .14rem;
					height: .14rem;
					cursor: pointer;
				}

				.imgItemImg {
					width: .86rem;
					height: .86rem;
					object-fit: cover;
				}
			}

			.addImgBox {
				width: .86rem;
				height: .86rem;
				border-radius: .04rem;
				background: #FFFFFF;
				border: 1px solid #EFD8B8;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				font-weight: 400;
				font-size: .12rem;
				color: #999999;
				cursor: pointer;
				line-height: .18rem;

				.addImg {
					margin-bottom: .08rem;
					width: .27rem;
					height: .23rem;
				}
			}
		}

		// 服务协议样式
		.agreement-container {
			margin: 0.16rem 0 0 1.38rem;
			font-size: 0.14rem;
		}

		.agreement-label {
			display: flex;
			align-items: center;
			cursor: pointer;
		}

		.agreement-checkbox {
			margin-right: 0.08rem;
			width: .16rem;
			height: .16rem;
			cursor: pointer;
		}

		.agreement-text {
			font-weight: 400;
			color: #333333;
			margin-right: 0.04rem;
		}

		.agreement-link {
			font-weight: 400;
			color: #E29358;
			text-decoration: none;

			&:hover {
				text-decoration: underline;
			}
		}

		// 按钮样式
		.register-btn {
			margin: .48rem auto .08rem;
			width: 3.85rem;
			height: 0.52rem;
			background: #E29358;
			padding: 0 0;
			border: none;
			border-radius: 0.04rem;
			font-size: 0.16rem;
			color: #252525;
			font-weight: 500;
			line-height: .52rem;
			cursor: pointer;
			transition: background-color 0.3s ease;

			&:hover {
				background: #D17F3A;
			}
		}

		.login-link-container {
			margin: 0 auto .48rem;
			display: flex;
			align-items: center;
			font-weight: 400;
			font-size: .14rem;
			color: #252525;
		}

		.login-link {
			font-weight: 400;
			color: #E29358;
			text-decoration: none;

			&:hover {
				text-decoration: underline;
			}
		}
	}

	::v-deep .el-form-item {
		margin-right: 0 !important;
		margin-bottom: .16rem !important;
		font-size: .14rem;
		line-height: 0.44rem;

		&__label {
			padding: 0 0;
			width: 1.38rem;
			height: 0.44rem;
			line-height: .44rem;
			font-size: .14rem;
		}

		&__content {
			font-size: .14rem;
			line-height: 0.44rem;
		}

		&__error {
			font-size: .12rem;
			padding-top: .02rem;
		}
	}
</style>